import { render } from "./pjByfastCode.vue?vue&type=template&id=1ea88fc7"
import script from "./pjByfastCode.vue?vue&type=script&lang=js"
export * from "./pjByfastCode.vue?vue&type=script&lang=js"

import exportComponent from "F:\\code\\ywym\\pda_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__